import { interpolateClamped } from '../../../core/utils/interpolate.js';
import {
  LARGE_CHART_SIZE,
  MEDIUM_CHART_SIZE,
  SMALL_CHART_SIZE,
} from '../../shared/constants.js';
import {
  THRESHOLD_INTERVAL_MAX_GAP,
  THRESHOLD_INTERVAL_MAX_OFFSET,
  THRESHOLD_INTERVAL_MAX_THICKNESS,
  THRESHOLD_INTERVAL_MID_OFFSET,
  THRESHOLD_INTERVAL_MIN_GAP,
  THRESHOLD_INTERVAL_MIN_OFFSET,
  THRESHOLD_INTERVAL_MIN_THICKNESS,
} from '../constants.js';

export interface ThresholdIntervalSizing {
  /** Height of each interval bar. */
  thickness: number;
  /** Gap between adjacent interval bars. */
  gap: number;
  /** Vertical offset between the meter bar and the interval bars. */
  offset: number;
}

/**
 * Resolves the interval bar sizing from the meter bar thickness.
 *
 * @param barThickness - The rendered meter bar thickness in pixels.
 */
export const getThresholdIntervalSizing = (
  barThickness: number,
): ThresholdIntervalSizing => {
  const thickness = interpolateClamped(
    barThickness,
    MEDIUM_CHART_SIZE,
    LARGE_CHART_SIZE,
    THRESHOLD_INTERVAL_MIN_THICKNESS,
    THRESHOLD_INTERVAL_MAX_THICKNESS,
  );
  const gap = interpolateClamped(
    barThickness,
    MEDIUM_CHART_SIZE,
    LARGE_CHART_SIZE,
    THRESHOLD_INTERVAL_MIN_GAP,
    THRESHOLD_INTERVAL_MAX_GAP,
  );
  const offset =
    barThickness <= MEDIUM_CHART_SIZE
      ? interpolateClamped(
          barThickness,
          SMALL_CHART_SIZE,
          MEDIUM_CHART_SIZE,
          THRESHOLD_INTERVAL_MIN_OFFSET,
          THRESHOLD_INTERVAL_MID_OFFSET,
        )
      : interpolateClamped(
          barThickness,
          MEDIUM_CHART_SIZE,
          LARGE_CHART_SIZE,
          THRESHOLD_INTERVAL_MID_OFFSET,
          THRESHOLD_INTERVAL_MAX_OFFSET,
        );

  return { thickness, gap, offset };
};
